import Form from "react-bootstrap/Form";
import "../../../src/main.css";
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import { BsX } from "react-icons/bs";
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import xlsx from "json-as-xlsx";
import { useNavigate } from "react-router-dom";
import {
  getFormattedStartDate,
  getFormattedEndDate,
  revenueRepStartDate,
  revenueRepEndDate,
} from "functionCall";
import {
  getCurrentUserRole,
  getFormattedDate,
  formatDate,
  decreaseDateByOneDay,
} from "modules/utilities/utility";

function CustomerFilter(props) {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const navigate = useNavigate();

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };
  const handleResetStartDate = () => {
    setStartDate("");
  };
  const handleResetEndDate = () => {
    setEndDate("");
  };

  const handleFilterSubmit = (event) => {
    event.preventDefault();
    const formattedStartDate = startDate ? formatDate(startDate) : null;
    const modifiedStartDate = decreaseDateByOneDay(formattedStartDate);
    const formattedEndDate = endDate ? formatDate(endDate) : null;
    const encodeStartDate = encodeURIComponent(revenueRepStartDate(startDate));
    const encodeEndDate = encodeURIComponent(revenueRepEndDate(endDate));
    if (startDate && endDate) {
      props.setStartDate(modifiedStartDate);
      props.setEndDate(formattedEndDate);
      navigate(
        `/customerFeedback?pageNumber=1&sd=${encodeStartDate}&ed=${encodeEndDate}`
      );
    } else {
      props.setStartDate("");
      props.setEndDate("");
      navigate(
        `/customerFeedback?pageNumber=1&sd=${encodeURIComponent(
          revenueRepStartDate(getFormattedStartDate())
        )}&ed=${encodeURIComponent(revenueRepEndDate(getFormattedStartDate()))}`
      );
    }
  };

  const handleOrder = (e) => {
    props.setInputChange(e.target.value);
  };

  const handleDownload = () => {
    const _data = props.sortData?.map((item) => {
      return {
        customer_name: item?.user?.first_name,
        agent_name: item?.rep?.first_name,
        display_id: item?.order_display_id,
        cart_link: item?.cart_link,
        cart_link_3m: item?.cart_link_3m,
        updated_at: getFormattedDate(item?.updatedAt),
      };
    });

    const data = [
      {
        sheet: "Customer Feedback Data",
        columns: [
          { label: "Customer Name", value: "customer_name" },
          { label: "Agent Name", value: "agent_name" || "-" },
          { label: "Order Display Id", value: "display_id" },
          { label: "Cart Link", value: "cart_link" },
          { label: "Cart Link (3 month)", value: "cart_link_3m" },
          { label: "Last Updated", value: "updated_at" },
        ],
        content: _data,
      },
    ];
    let settings = {
      fileName: "Customer Feedback Data",
      extraLength: 3,
      writeMode: "writeFile",
      writeOptions: {},
    };

    xlsx(data, settings);
  };

  return (
    <>
      <div className="d-flex gap-2">
        <div className="mt-1">
          <Form.Group
            className="mb-3"
            controlId="exampleForm.ControlInput1"
            onChange={handleOrder}
          >
            <Form.Control
              type="text"
              placeholder="Order_id/ phone/ email/ case_id"
            />
          </Form.Group>
        </div>
        <Form onSubmit={handleFilterSubmit} className="data-filter">
          <div className="d-flex gap-2">
            <Form.Group>
              <div className="input-container mt-1">
                {startDate ? (
                  ""
                ) : (
                  <div className="calendar-icon-container">
                    <FontAwesomeIcon
                      icon={faCalendarAlt}
                      className="calendar-icon"
                    />
                  </div>
                )}
                <DatePicker
                  selected={startDate}
                  onChange={handleStartDateChange}
                  placeholderText="Start Date"
                  dateFormat="dd-MM-yyyy"
                  value={startDate ? formatDate(startDate) : ""}
                  className="input-with-icon"
                />
                {startDate && (
                  <span className="reset-icon" onClick={handleResetStartDate}>
                    <BsX />
                  </span>
                )}
              </div>
            </Form.Group>
            <Form.Group>
              <div className="input-container mt-1">
                {endDate ? (
                  ""
                ) : (
                  <div className="calendar-icon-container">
                    <FontAwesomeIcon
                      icon={faCalendarAlt}
                      className="calendar-icon"
                    />
                  </div>
                )}
                <DatePicker
                  selected={endDate}
                  onChange={handleEndDateChange}
                  placeholderText="End Date"
                  dateFormat="dd-MM-yyyy"
                  value={endDate ? formatDate(endDate) : ""}
                />
                {endDate && (
                  <span className="reset-icon" onClick={handleResetEndDate}>
                    <BsX />
                  </span>
                )}
              </div>
            </Form.Group>
            <Button variant="primary" className="mt-1 w-100" type="submit">
              Filter
            </Button>
            {["admin"].includes(getCurrentUserRole()) && (
              <Button
                variant="primary"
                className={
                  props.sortData?.length === 0
                    ? "disabled mt-1 w-100"
                    : "mt-1 w-100"
                }
                onClick={handleDownload}
                style={{ width: "20rem" }}
              >
                Download
              </Button>
            )}
          </div>
        </Form>
      </div>
    </>
  );
}
export default CustomerFilter;
